import { createClient } from '@/shared/api';
import type { DownloadPdfReportMutation, DownloadPdfReportMutationVariables } from '@/shared/api';
import DOWNLOAD_PDF_REPORT_MUTATIONS from '../mutations/downloadPdfReport';

/**
 * Requests the PDF rendering of a study or event report for download. Runs the downloadPdfReport mutation with markAsDownloaded set to false and throws the returned message unless it reports success, otherwise yielding the whole mutation result.
 *
 * @param id - Report identifier.
 * @param studyFid - Study FID the report belongs to.
 * @param reportType - Type of report to render.
 * @param reportId - Identifier of the report to render.
 * @param eventFid - Event FID for event reports.
 * @returns A promise resolving to the full downloadPdfReport mutation result.
 */
const handleDownloadPdfReport = async ({ id, studyFid, reportType, reportId, eventFid }: any) => {
  const client = createClient();
  const downloadPdfReportResult = await client.mutate<
    DownloadPdfReportMutation,
    DownloadPdfReportMutationVariables
  >({
    mutation: DOWNLOAD_PDF_REPORT_MUTATIONS,
    variables: {
      id,
      studyFid,
      reportType,
      reportId,
      eventFid,
      markAsDownloaded: false,
    },
  });
  const { data } = downloadPdfReportResult;
  const downloadPdfReport = data?.downloadPdfReport;
  if (!downloadPdfReport?.isSuccess) {
    throw new Error(downloadPdfReport?.message ?? undefined);
  }
  return downloadPdfReportResult;
};

export default handleDownloadPdfReport;
